import { Router, Route, ReactLocation } from "@tanstack/react-location";
import { globalStyles } from "./styles/global";
import { AppPage } from "./pages/app.page";
import { IntroPage } from "./pages/intro.page";
import { VFC } from "react";

const location = new ReactLocation();

const routes: Route[] = [
  {
    path: "/",
    element: <IntroPage />,
  },
  {
    path: "/app",
    element: <AppPage />,
  },
];

export const App: VFC = () => {
  globalStyles();
  return <Router routes={routes} location={location} />;
};
